module.exports = __webpack_public_path__ + "img/saldo@2x.292f654.png";